export const WIDGET_ROOT_TAG = 'ffg-widget-root';
export const WIDGET_SCRIPT_TAG = 'ffg-widget';
